import { memo } from 'react'
import { useTranslation } from 'services/Translation'
import styled from 'styled-components'
import { textPrimary } from 'styles/Colors'

const Container = styled.div`
  width: 100%;
  padding: 2rem;
  text-align: center;
`

const Title = styled.h2`
  font-family: 'BasierCircle', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${textPrimary};
  margin-bottom: 1rem;
`

const Description = styled.p`
  font-family: 'BasierCircle', sans-serif;
  font-size: 1rem;
  color: #6b7280;
`

const texts = (getText) => (key) =>
  ({
    title: getText('Settings', 'Account_Settings'),
    description: getText('Settings configuration will be available soon.', 'Account_Settings'),
  }[key])

const Settings = () => {
  const { t } = useTranslation(texts)

  return (
    <Container>
      <Title>{t('title')}</Title>
      <Description>{t('description')}</Description>
    </Container>
  )
}

Settings.whyDidYouRender = true

export default memo(Settings)